/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TreatmentInfo/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import * as fromFormat from 'Data/format.js'
import Content from './Content/index'
import No from './No/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function TreatmentInfo({
  children,
  viewPath = "/DesignSystem/PatientInformation/Content/Relations/Content/Relation/TreatmentInfo"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let relationFromPersonRecordPatientAppointmentsValueData = fromData.useDataFormat({ viewPath,
context: 'relation',
path: 'from_person_record.patient.appointments',
format: fromFormat.isNotEmptyList,
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: Boolean(relationFromPersonRecordPatientAppointmentsValueData),
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Content'}>
<Content
  viewPath={`${viewPath}/Content`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}